/*
 * @Descripttion: 
 * @version: 
 * @Author: hanzb
 * @Date: 2019-11-29 16:43:46
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-26 09:18:46
 */
/**
 * 统一获取事件，优先从事件集中获取，其次是旧模式
 * @param {object} module 
 * @param {string} eventKey 事件名
 */
let getFunctionByKey = (module, eventKey) => {
	if (!module || !eventKey) return null;
	let { objFct, moduleDesc } = module.props;
	if (moduleDesc && moduleDesc.eventKeys && moduleDesc.eventKeys[eventKey]) {
		// 事件集模式
		let funs = Object.assign({}, objFct ? objFct.get("@funs") : {}, module.funs);
		let key = moduleDesc.eventKeys[eventKey];
		return typeof funs[key] == "function" ? funs[key].bind(funs) : funs[key];
	} else {
		// 原事件模式
		// return module.data.functions[eventKey];
		// let functions = module.data && module.data.functions || module.state.functions || {};
		// return functions[eventKey];
		return (module.data && module.data.functions && module.data.functions[eventKey])//在data.functions中查找
			|| (module.state.functions && module.state.functions[eventKey])//在state.functions中查找
		// || (module.state && module.state[eventKey]);//在state中查找
	}
}
/**
 * 其他位置需要存放方法，统一使用getFunctionByKey调用时使用
 * @param {object} module module
 * @param {string} key 存放方法的key
 * @param {function} fun 存放的方法
 */
let setFunction = (module, key, fun) => {
	if (!module || !key || !fun) return;
	if (module.data && module.data.functions) {
		module.data.functions[key] = fun;
	} else if (module.state && module.state.functions) {
		module.state.functions[key] = fun;
	} else {
		if (module.data) module.data.functions = { [key]: fun };
		else module.data = { functions: { [key]: fun } };
	}
}

/**
 * 统一获取常量，从对象工厂中获取，由事件集配置定义，获取不到直接返回原字符串
 * @param {object} module 
 * @param {string} cnstKey 常量名
 */
let getConstByKey = (module, cnstKey) => {
	if (!module || !cnstKey || typeof cnstKey !== "string") return cnstKey;
	let { objFct, moduleDesc } = module.props;
	if (!objFct) return cnstKey;
	let cnsts = objFct.get("@cnsts");
	if (!cnsts) return cnstKey;
	return (cnstKey in cnsts) ? cnsts[cnstKey] : cnstKey;
}

/**
 * 校验当前react版本
 * @param {object} module 当前控件this
 * @param {number|string} vsn 版本号
 */
let testReactVsn = (module, vsn) => {
	if (!module || !vsn) return;
	switch (parseInt(vsn)) {
		case 15:
			return module._reactInternalInstance;
		case 16:
			return module._reactInternalFiber;
		default:
			break;
	}
}

/**
 * 给包含数字的字符串添加px单位（antd4部分控件需要指定单位）
 * @param {string} [str=""] 需要添加单位字符串
 * @param {string} [addUnit=px] 要添加的单位，默认"px"
 */
let numStrAddPx = (str = "", addUnit = "px") => {
	return str.replace(/([\d]+)($|[^\d(px|vm)%])/g, `$1${addUnit}$2`);
}

export { getFunctionByKey, setFunction, getConstByKey, testReactVsn, numStrAddPx }


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiBaseComp/SgiCommon.js